import React from 'react';
import '../../assets/styles/StepOne.css';
import arrowIcon from '../../assets/images/ARISE WEBSITE_microsite-19.png';
// import yourImage from '../../assets/images/Horizontal.png'
import yourImage from '../../assets/images/round 1.svg'
// import vertical from '../../assets/images/Vertical.png'
import vertical from '../../assets/images/round 2.svg'

const StepOne = () => {
  return (
    // <div className="step-one-wrapper">
    //   <h2 className="step-title">Step 1: Register & Enroll</h2>
    //   <p className="step-subtitle">Start your journey with a solid foundation.</p>

    //   <div className="step-circles-container">
    //     {/* Step 1 */}
    //     <div className="circle-item">
    //       <div className="circle-progress">
    //         <div className="arrow-button">
    //           <img src={arrowIcon} alt="arrow" />
    //         </div>
    //       </div>
    //       <div className="circle-text">
    //         <p><span className="highlight">Eligibility:</span><br />
    //           Open to all students currently in undergraduate, post-graduate, or diploma programs.
    //         </p>
    //       </div>
    //     </div>

    //     {/* Step 2 */}
    //     <div className="circle-item">
    //       <div className="circle-progress">
    //         <div className="arrow-button">
    //           <img src={arrowIcon} alt="arrow" />
    //         </div>
    //       </div>
    //       <div className="circle-text">
    //         <p><span className="highlight">Course Access:</span><br />
    //           Visit the ARISE FOR YOU™ portal and register by entering the required details, and paying for the Entrepreneurship and Small Business (ESB) Certification Course.
    //         </p>
    //       </div>
    //     </div>

    //     {/* Step 3 */}
    //     <div className="circle-item">
    //       <div className="circle-progress">
    //         <div className="arrow-button">
    //           <img src={arrowIcon} alt="arrow" />
    //         </div>
    //       </div>
    //       <div className="circle-text">
    //         <p><span className="highlight">Get Started:</span><br />
    //           Once registered, you’ll gain access to the ESB Certification Course Modules, designed to help you build real-world business acumen.
    //         </p>
    //       </div>
    //     </div>
    //   </div>

    //   <p className="step-footer">
    //     The ESB Certification course is self-paced, accessible online, and focuses on essential business skills –
    //     from planning and strategy to marketing and finance.
    //   </p>
    // </div>
       <div className="step-one-container">
      <h2 className="step-title-one font-bold">Step 1: Register & Enroll</h2>
      <div className="esb-help-separator"></div>
      <p className="step-subtitle font-regualr">Start your journey with a solid foundation.</p>
      <div className="step-image-wrapper">
        <img src={yourImage} alt="Step Desktop" className="step-image desktop-only" />
        <img src={vertical} alt="Step Mobile" className="step-image mobile-only" />
      </div>
      <p className="step-footer font-regular">
        The ESB Course is self-paced, accessible online, and focuses on essential business skills –
        from planning and strategy to marketing and finance.
      </p>
    </div>
  );
};

export default StepOne;
